import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
export default {
  name: "nextStep",
  props: {
    btn1BgColor: {
      type: String,
      default: "#1890FF"
    },
    btn1text: {
      type: String,
      default: "下一步"
    },
    btn1textColor: {
      type: String,
      default: "white"
    },
    btn2BgColor: {
      type: String,
      default: "#fff"
    },
    btn2text: {
      type: String,
      default: "取消"
    },
    btn2textColor: {
      type: String,
      default: "black"
    },
    // 用于维护期间禁用签署按钮
    disabled1: {
      type: Boolean,
      default: false
    },
    disabled2: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    btn1Style: function btn1Style() {
      return "background:".concat(this.btn1BgColor, ";color:").concat(this.btn1textColor);
    },
    btn2Style: function btn2Style() {
      return "background:".concat(this.btn2BgColor, ";color:").concat(this.btn2textColor);
    }
  },
  methods: {
    btn1Click: function btn1Click() {
      this.$emit("btn1callBack");
    },
    btn2Click: function btn2Click() {
      this.$emit("btn2callBack");
    }
  }
};